import styled from 'styled-components';
import { ContainerV2, RowFlexContainer } from '../../stories/atoms/containerV2/ContainerV2';

type ContentWrapperProps = {
  isOpen: boolean;
};

export const ContentWrapper = styled.div<ContentWrapperProps>`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  flex-direction: column;
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundDark : color.white};
  box-shadow: ${({ theme: { palette } }) =>
    palette.mode === 'dark' ? '-20px 20px 40px -4px #0000003D' : '0px 2px 11px #ababab'};
  overflow: hidden;
  animation: fadeIn 200ms ease-out;

  ${({ theme: { breakpoints } }) => breakpoints.up('tabletPortrait')} {
    max-height: 70vh;
    max-width: 400px;
    position: relative;
    border-radius: ${({ theme: { spacing } }) => spacing(3)};
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`;

export const HeaderContainer = styled(RowFlexContainer)`
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundPaperDark : color.baseGray};
`;

export const InputContainer = styled(ContainerV2)`
  box-sizing: border-box;
`;

export const StyledSubmitButton = styled.button`
  height: ${({ theme }) => theme.spacing(10)};
  width: ${({ theme }) => theme.spacing(10)};
  right: ${({ theme }) => theme.spacing(3)};
  top: ${({ theme }) => `calc((100% - ${theme.spacing(10)}) / 2)`};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: none;
  position: absolute;
  background: none;
  cursor: pointer;

  > div {
    color: ${({ theme: { color, palette } }) => palette.mode === 'dark' && color.primary};
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 100%;
  border: ${({ theme: { color } }) => `1px solid ${color.borderGray}`};
  padding: ${({ theme }) => theme.spacing(0, 3)};
`;
